import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource' //
import './helpers/components'

Vue.use(VueResource) //

Vue.config.productionTip = false
//Vue.prototype.$http = axios

Vue.filter('enclose', function (value) {
  if (!value) return ''
  return '(' + value + ')'
})
Vue.filter('setgender', function (value) {
  if (!value) return ''
  return value == 1? 'männlich': 'weiblich'
})
Vue.filter('sortdate', function (value) {
  if (!value) return ''
  let pdate = new Date(value)
  return ('0' + pdate.getDate()).slice(-2) + '.' + ('0' + (pdate.getMonth()+1)).slice(-2) + '.' + pdate.getFullYear()
})
Vue.filter('completePaymentType', function (value) {
  if (!value) return ''
  const type = { ue: 'Überweisung', 'ls': 'Lastschrift'}
  return type[value]
})
Vue.filter('paymentInterval', function (value) {
  if (!value) return ''
  const type = { '1': 'monatliche', '12': 'jährliche'}
  return type[value]
})

Vue.filter('replacePoint', function (value) {
  if (!value) return ''
  return (value.toString().replace(/\./, ','))
})

Vue.filter('stripTags', function (value) {
  if (!value) return ''
  return value.replace(/(<([^>]+)>)/gi, "")
})

Vue.mixin({
  methods: {
    calcPrice: function(agePriceList, seconds) {
      var priceObj = '';
        var sec = 1000000000;
        let failPrize = 1000000000;

        for (var secs in agePriceList) {
          failPrize = agePriceList[secs]
          if (secs >= seconds && secs < sec) {

              priceObj = agePriceList[secs]
              sec = secs;
              break;
          }
        }

        if (priceObj == '') {
          priceObj = failPrize
        }

        var price = priceObj.price;

        if (priceObj.type == 1) {
            price = (price / 12).toFixed(2);
        }

        return price
    },
    calcAgeInSeconds(birthdate) {
      var t1 = new Date()
      var t2 = new Date(birthdate)
      var diff = (t1.getTime() - t2.getTime()) /1000

      return Math.round(diff)
    },
    getMatrix(lead, registry, id) {
      const race = ['', 'dog', 'cat']
      const product = registry.productByID[id]

      let matrix = [];
      let breeds = registry.dogbreedsByName

      if(lead.race == 2) {
        breeds = registry.catbreedsByName
      }

      if (lead.breed_id && !breeds[lead.breed]) {
        let breedClassId = 1;
        if (lead.race == 1) {
          Object.keys(breeds).forEach(breedName => {
            if (breeds[breedName].breed_id == lead.breed_id) {
              breedClassId = breeds[breedName].breed_class_id;
            }
          })
        }
        lead.breed_class_id = breedClassId
      } else {
        const breed_class_id = lead.race == 1 && breeds[lead.breed] ? breeds[lead.breed].breed_class_id: 1;
        lead.breed_class_id = breed_class_id
      }

      if (registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][0] !== undefined
        && lead.race == 1 || registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][1] === undefined) {
        matrix = registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][0]
      }
      else {
        matrix = registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][lead.breed_class_id]
      }

      return matrix
    },
    optimizelyIsVariant (experimentId, expectedVariation) {
      if (window["optimizely"]) {
        const experiment = window["optimizely"].get('state').getExperimentStates()[experimentId];
        if (experiment && experiment.isActive && experiment.variation.id == expectedVariation) return true;
      }
      return false;
    },
    pushDataLayer(typename, name, entry = '', crosselling = false, leadin = null) {
      if (this.registry.cc &&
          (this.registry.cc.includes("gat") ||
              this.registry.cc.includes("all") ||
              this.registry.cc.includes("marketing"))) {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({[typename]: null});
          window.dataLayer.push({ecommerce: null})

          if (typename !== 'ecommerce') {
            window.dataLayer.push({
              event: "select_" + name,
              [typename]: {[name]: entry},
              ecommerce: {
                items: this.getTrackingProductItems(crosselling, leadin)
              }
            })
          } else {
            window.dataLayer.push({
              event: "select_" + name,
              ecommerce: {
                [name]: entry,
                items: this.getTrackingProductItems(crosselling, leadin)
              }
            })
          }
         } catch (e) {
          console.error(e);
        }
      }
    },
    calculateAge(birthDate) {
      const birthDateObj = new Date(birthDate);
      const currentDateObj = new Date();
      let age = currentDateObj.getUTCFullYear() - birthDateObj.getUTCFullYear();

      const birthMonth = birthDateObj.getUTCMonth();
      const currentMonth = currentDateObj.getUTCMonth();
      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDateObj.getUTCDate() < birthDateObj.getUTCDate())) {
        age--;
      }

      if (age === 0) {
        return Math.round((currentDateObj - birthDateObj) / (1000 * 3600 * 24) / 30) + ' Monate';
      } else if (age === 1) {
        return age + ' Jahr';
      } else {
        return age + ' Jahre';
      }
    },
    getTrackingProductItems(crosselling = false, leadin = null) {
      let productItems = [{
        item_id: this.registry.productByID[leadin ? leadin.productActive : this.leadin.productActive].abbreviation,
        item_name: this.registry.productByID[leadin ? leadin.productActive : this.leadin.productActive].idd_name,
        item_category: this.registry.productByID[leadin ? leadin.productActive : this.leadin.productActive].abbreviation,
        brand: 'Agila',
        price: leadin ? (leadin.productPrice ? Number(leadin.productPrice) : null) : (this.leadin.productPrice ? Number(this.leadin.productPrice) : null),
        quantity: 1
      }];
      if (crosselling) {
        productItems.push({
          item_id: this.registry.productByID[crosselling].abbreviation,
          item_name: this.crossP.name,
          item_category: this.registry.productByID[crosselling].abbreviation,
          brand: 'Agila',
          price: Number(this.crossP.price),
          quantity: 1
        });
      }
      return productItems;
    },
    isHPS(lead) {
      return lead.productActive == 5 || lead.productActive == 6 || lead.productActive == 7;
    }
  }
})
new Vue({
  render: h => h(App),
}).$mount('#app')
